module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-day-one__form"
  }, [_c('control', {
    attrs: {
      "label": "Disease or Accident",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseOrAccident),
      expression: "diseaseOrAccident"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseOrAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "disease"
    }
  }, [_vm._v("Disease")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "accident"
    }
  }, [_vm._v("Accident")])])]), _vm._v(" "), (_vm.diseaseOrAccident === 'disease') ? _c('control', {
    attrs: {
      "label": "Disease Type",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseType),
      expression: "diseaseType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asbestos Related Lung Cancer"
    }
  }, [_vm._v("Asbestos Related Lung Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Bladder Cancer"
    }
  }, [_vm._v("Bladder Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Kidney Cancer"
    }
  }, [_vm._v("Kidney Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Laryngeal Cancer"
    }
  }, [_vm._v("Laryngeal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Leukemia"
    }
  }, [_vm._v("Leukemia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Liver Cancer"
    }
  }, [_vm._v("Liver Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mesothelioma"
    }
  }, [_vm._v("Mesothelioma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nasal Cancer"
    }
  }, [_vm._v("Nasal Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Skin Cancer"
    }
  }, [_vm._v("Skin Cancer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other Cancer"
    }
  }, [_vm._v("Other Cancer")])])]) : _vm._e(), _vm._v(" "), (_vm.diseaseOrAccident === 'accident') ? _c('control', {
    attrs: {
      "label": "Accident Type",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accidentType),
      expression: "accidentType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.accidentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - EL"
    }
  }, [_vm._v("Accident - EL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accident - PL"
    }
  }, [_vm._v("Accident - PL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Motor"
    }
  }, [_vm._v("Motor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other")])])]) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Gender of Claimant",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please Select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Claimant's DOB",
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:dob",
      value: (_vm.dobRules),
      expression: "dobRules",
      arg: "dob"
    }],
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('dob')
    }
  }, [_vm._v("\n            The person must be born in the past\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Onset of Symptoms",
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:osos",
      value: (_vm.oSoSRules),
      expression: "oSoSRules",
      arg: "osos"
    }],
    model: {
      value: (_vm.onsetOfSymptoms),
      callback: function($$v) {
        _vm.onsetOfSymptoms = $$v
      },
      expression: "onsetOfSymptoms"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('osos')
    }
  }, [_vm._v("\n            The symptoms must be before the date of death\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Date of Assessment (or assumed)",
      "icon-space": false
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:assumed",
      value: (_vm.assumedRules),
      expression: "assumedRules",
      arg: "assumed"
    }],
    model: {
      value: (_vm.assumedSettlement),
      callback: function($$v) {
        _vm.assumedSettlement = $$v
      },
      expression: "assumedSettlement"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('assumed')
    }
  }, [_vm._v("\n            The assessment date must be after death.\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Claimant's Assumed Life Expectancy",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assumedLifeExpectancyMethod),
      expression: "assumedLifeExpectancyMethod"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "claimants_assumed_dod_type",
      "id": "claimants_assumed_dod_type",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assumedLifeExpectancyMethod = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateAssumedLifeExpectancy]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_years_and_months_left"
    }
  }, [_vm._v("Enter Years/Months")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_date"
    }
  }, [_vm._v("Enter Date")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_age_at_death"
    }
  }, [_vm._v("Enter Age at Death (years)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_percentage_of_life"
    }
  }, [_vm._v("% of Normal Life Expectancy")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_reduction_in_life"
    }
  }, [_vm._v("% Reduction in Normal Life Expectancy")])])]), _vm._v(" "), (_vm.assumedLifeExpectancyMethod === 'assumed_age_at_death') ? _c('control', {
    attrs: {
      "label": "Claimant's Age at Assumed Death",
      "icon-space": false,
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.assumedAgeAtDeath),
      expression: "assumedAgeAtDeath",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "disabled": _vm.assumedLifeExpectancyMethod !== 'assumed_age_at_death',
      "name": "claimants_age_at_assumed_death",
      "type": "number"
    },
    domProps: {
      "value": (_vm.assumedAgeAtDeath)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.assumedAgeAtDeath = _vm._n($event.target.value)
      }, _vm.updateAssumedLifeExpectancy],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.minAgeRules
    }
  }, [_vm._v("\n            The claimant's age at death is required and should be at least " + _vm._s(_vm.currentAge) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.assumedLifeExpectancyMethod === 'assumed_years_and_months_left') ? _c('control', {
    attrs: {
      "icon-space": false,
      "label": "Enter Years/Months From Today"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.yearsLeft),
      expression: "yearsLeft",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "id": "years"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.yearsLeft = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateAssumedLifeExpectancy]
    }
  }, _vm._l((76), function(year) {
    return _c('option', {
      domProps: {
        "value": year - 1
      }
    }, [_vm._v(_vm._s(year - 1) + " year(s)")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.monthsLeft),
      expression: "monthsLeft",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "id": "months"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.monthsLeft = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateAssumedLifeExpectancy]
    }
  }, _vm._l((12), function(month) {
    return _c('option', {
      domProps: {
        "value": month - 1
      }
    }, [_vm._v("\n                        " + _vm._s(month - 1) + " month(s)\n                    ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.assumedLifeExpectancyMethod == 'assumed_percentage_of_life') ? _c('control', {
    attrs: {
      "icon-space": false,
      "label": "Percentage of Normal Life Expectancy",
      "before-after": "percent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerAssumedLifeExpectancy.percentageOfNormalLifeExpectancy),
      expression: "innerAssumedLifeExpectancy.percentageOfNormalLifeExpectancy",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.assumedLifeExpectancyMethod != 'assumed_percentage_of_life',
      "required": "",
      "max": "100",
      "min": "1",
      "name": "percentage_of_normal_life_expectancy",
      "type": "number"
    },
    domProps: {
      "value": (_vm.innerAssumedLifeExpectancy.percentageOfNormalLifeExpectancy)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerAssumedLifeExpectancy, "percentageOfNormalLifeExpectancy", _vm._n($event.target.value))
      }, _vm.updateAssumedLifeExpectancy],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('percentage_of_normal_life_expectancy')
    }
  }, [_vm._v("\n            The percentage of normal life expectancy must be number between 1 and 100\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.assumedLifeExpectancyMethod == 'assumed_reduction_in_life') ? _c('control', {
    attrs: {
      "label": "Percentage Reduction in Normal Life Expectancy",
      "icon-space": false,
      "before-after": "percent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerAssumedLifeExpectancy.percentageReductionInNormalLifeExpectancy),
      expression: "innerAssumedLifeExpectancy.percentageReductionInNormalLifeExpectancy",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.assumedLifeExpectancyMethod != 'assumed_reduction_in_life',
      "required": "",
      "max": "100",
      "min": "1",
      "name": "percentage_reduction_in_normal_life_expectancy",
      "type": "number"
    },
    domProps: {
      "value": (_vm.innerAssumedLifeExpectancy.percentageReductionInNormalLifeExpectancy)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerAssumedLifeExpectancy, "percentageReductionInNormalLifeExpectancy", _vm._n($event.target.value))
      }, _vm.updateAssumedLifeExpectancy],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('percentage_reduction_in_normal_life_expectancy')
    }
  }, [_vm._v("\n            The percentage reduction in normal life expectancy must be number between 1 and 100\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "icon-space": false,
      "label": "Claimant's Assumed Date of Death"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:claimants_assumed_date_of_death.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "claimants_assumed_date_of_death",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "disabled": _vm.assumedLifeExpectancyMethod !== 'assumed_date'
    },
    on: {
      "input": _vm.updateAssumedLifeExpectancy
    },
    model: {
      value: (_vm.assumedDateOfDeath),
      callback: function($$v) {
        _vm.assumedDateOfDeath = $$v
      },
      expression: "assumedDateOfDeath"
    }
  })], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Employed or Retired",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentType),
      expression: "employmentType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employmentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please Select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "retired"
    }
  }, [_vm._v("Retired")])])]), _vm._v(" "), (_vm.employmentType == 'employed') ? _c('div', [_c('control', {
    attrs: {
      "label": "Gross Annual Salary",
      "before-after": "pound",
      "icon-space": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salary),
      expression: "salary"
    }],
    attrs: {
      "type": "text",
      "min": "0"
    },
    domProps: {
      "value": (_vm.salary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.salary = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.gender) ? _c('salary-finder', {
    attrs: {
      "gender": _vm.gender
    },
    on: {
      "update": _vm.updateSalary
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Procedural Status",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proceduralStatus),
      expression: "proceduralStatus"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.proceduralStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please Select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pre-lit"
    }
  }, [_vm._v("Pre-Litigation")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "litigated"
    }
  }, [_vm._v("Litigated")])])]), _vm._v(" "), (_vm.showErrorMessage) ? _c('div', [_c('span', {
    staticClass: "a-form-inputs--error"
  }, [_vm._v("You must complete all fields.")])]) : _vm._e(), _vm._v("\n    Calculate the results:\n    "), _c('div', [_c('button', {
    staticClass: "a-button u-no-margin",
    on: {
      "click": _vm.calculate
    }
  }, [_vm._v("Calculate")]), _vm._v(" "), _c('button', {
    staticClass: "a-button u-no-margin",
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Reset")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cb618f86!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reserving/day-one/lost/Form.vue
// module id = 1808
// module chunks = 0